import { forwardRef } from "react"
import { twMerge } from "tailwind-merge"

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> { }

const Box = forwardRef<HTMLDivElement, BoxProps>(({
  className,
  ...props
}: BoxProps, ref) => {
  return (
    <div ref={ref} className={twMerge('bg-white-100 p-6 rounded-sm', className)} {...props} />
  )
});

export default Box
